import { POST,postJson } from "../../index";

export const selectCarCheck = (param) => POST("/v1/CarCheck/selectCarCheck", param);
export const insertCarCheck = (param) => POST("/v1/CarCheck/insertCarCheck", param);
export const updateCarCheck = (param) => POST("/v1/CarCheck/updateCarCheck", param);
export const deleteCarCheck = (param) => POST("/v1/CarCheck/deleteCarCheck", param);
export const moveCarCheck = (param) => postJson("/v1/CarCheck/moveCarCheck", param);

export const selectCheckList = (param) => POST("/v1/CarCheck/selectEventSpotCheckRecordList", param);
export const selectCheckRate = (param) => POST("/v1/CarCheck/selectSpotCheckRate", param);
export const selectStateRate = (param) => POST("/v1/CarCheck/selectAbnormalRate", param);

export const selectSpotCheck = (param) => POST("/v1/spotCheck/selectSpotCheck", param);
export const selectSpotCheckStatement = (param) => POST("/v1/spotCheck/selectSpotCheckStatement", param);
export const insertSpotCheck = (param) => POST("/v1/spotCheck/insertSpotCheck", param);
export const querySpotCheckReport = (param) => POST("/v1/spotCheck/querySpotCheckReport", param);

